@for (legTracking of legTrackingDetails(); track $index) {
    <div class="mybets-betslip-betbuilder_expanded-leg clearfix">
        <div class="mybets-betslip-betbuilder_expanded-bet-leg-details">
            <div class="betbuilder-expanded-leg-bet-details">
                <ms-my-bets-multi-bet-card-indicator
                    [bet]="bet()"
                    [event]="event()"
                    [myBetsBetBuilderLeg]="legTracking.leg"
                    [result]="legTracking.leg.betState" />
                <div class="leg-details">
                    <span class="betbuilder-leg-name highlight">{{ legTracking.leg.name }}</span>
                    @if (legTracking.showTwoUpMarketSignText) {
                        <ms-my-bets-text-badge [badgeKind]="mybetsTextBadgeModel.EarlyPayout" />
                    }
                </div>
            </div>
            @if (legTracking.leg.cancellationReason) {
                <div class="cancellation-reason">
                    <span class="title">{{ sitecoreMyBets.myBets.CancellationReason }} </span>
                    <span class="highlight">{{ legTracking.leg.cancellationReason }}</span>
                </div>
            }
            @if (legTracking.leg.marketId && legTracking.trackingDetails.visualizationType !== noVisualization) {
                <ms-my-bets-visualization
                    [event]="event()"
                    [bet]="bet()"
                    [visualizationType]="legTracking.trackingDetails.visualizationType"
                    [myBetsListContext]="myBetsListContext()"
                    [cashedOut]="cashedOut()"
                    [myBetsBetBuilderLeg]="legTracking.leg" />
            }
        </div>
    </div>
}
